import { useEffect, useCallback } from "react";
import type {
  EmbeddedJourneyPrefillCallback,
  EmbeddedJourneyPrefill,
  UiSdkOptions,
} from "@wf-financing/embedded-types";

export const useEmbedCta = (targetId: string, companyToken?: string | null) => {
  const triggerCta = useCallback(async () => {
    const options: UiSdkOptions = { isSandbox: true };
    if (!companyToken) return;

    const partnerCallback: EmbeddedJourneyPrefillCallback = () => {
      const raw = localStorage.getItem("prefill-config");
      if (!raw) return;
      try {
        return JSON.parse(raw) as EmbeddedJourneyPrefill;
      } catch (error) {
        console.warn(
          "Failed to parse prefill-config from localStorage:",
          error,
        );
      }
    };

    if (import.meta.env.DEV && !import.meta.env.VITE_USE_REAL_SDK) {
      const { mountToTarget } = await import("@wf-financing/ui");
      await mountToTarget(targetId, partnerCallback, companyToken, options);
    } else {
      const { WayflyerUiSdk } = await import("@wf-financing/ui-sdk");
      const sdk = await WayflyerUiSdk.loadSdk(companyToken, options);
      sdk.mountCta(targetId, partnerCallback);
    }
  }, [companyToken, targetId]);

  useEffect(() => {
    triggerCta();
  }, [triggerCta]);

  return triggerCta;
};
